__turbopack_context__.v({
  "header": "Header-module__MbOHlW__header",
  "headerActive": "Header-module__MbOHlW__headerActive",
  "headerButton": "Header-module__MbOHlW__headerButton",
  "headerContainer": "Header-module__MbOHlW__headerContainer",
  "headerImage": "Header-module__MbOHlW__headerImage",
});
